/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BreadcrumbsComponent} from './breadcrumbs.component';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [BreadcrumbsComponent],
    exports: [
        BreadcrumbsComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ]
})
export class BreadcrumbsModule {
}
